document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});



document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.product__description.rte');
  const insertAfterElement = document.querySelector('.tee-block.tee-product-price');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.after(elementToMove)
  } 
})
// setTimeout(() =>{
//   const cart = document.querySelectorAll('.cart-items .cart-item .cart-item__details')
//   cart.forEach ((el) =>{
//   const productOptionList = el.querySelectorAll('.product-option')
//   productOptionList.forEach((option) => {
//       const textContent = option.textContent.trim(); // Get trimmed text content
//       if (textContent.includes("Available Product:") || textContent.includes("Color:")) {
//         option.remove(); // Remove the option element
//       }
//     });
//   })
// },1000)